import React, { useMemo } from 'react';
import { DefaultTheme } from 'styled-components';
import { BadgesContainer } from './TagsBadgeList.styles';
import Badge from '@/components/badge/Badge';

type TagListType = {
  label: MultiSelectField['label'];
  value: MultiSelectField['value'];
  color: keyof DefaultTheme['color'] & string;
};

export interface TagsBadgeListType {
  tags: PacoteItineraryType['tags'];
  position?: 'absolute';
}

const TagsBadgeList = ({ position, tags }: TagsBadgeListType) => {
  const tagsList: TagListType[] | null = useMemo(() => {
    if (tags && tags.length > 0) {
      let badgeColor: keyof DefaultTheme['color'] & string;

      const tagColorized: TagListType[] = [];

      tags.forEach((tag) => {
        switch (tag.value.toUpperCase()) {
          case 'OFERTA':
            badgeColor = 'destructive_500';
            break;
          case 'COM AÉREO':
            badgeColor = 'dark';
            break;
          case 'GRUPO EXCLUSIVO':
          case 'EXCLUSIVO':
            badgeColor = 'success_500';
            break;
          default:
          case 'NOVO':
            badgeColor = 'white';
            break;
        }

        const item = {
          ...tag,
          color: badgeColor,
        };

        tagColorized.push(item);
      });
      return tagColorized;
    }
    return null;
  }, [tags]);

  if (!tagsList?.length) {
    return null;
  }

  return (
    <BadgesContainer position={position}>
      <>
        {tagsList.map(({ value, color }) => (
          <Badge key={value} color={color} size="sm">
            {value}
          </Badge>
        ))}
      </>
    </BadgesContainer>
  );
};

export default TagsBadgeList;
